import { BreadcrumbsLdJson } from 'components/ld-json/breadcrubms';
import { Breadcrumbs } from 'components/ui/breadcrumbs';
import { useBreadcrumbI18n } from 'hooks/use-breacrumbs';

type CamperlabBreadcrumbsProps = {
  i18nKeys: { family?: string; target?: string; brand?: string };
};

export function CamperlabBreadcrumbs({ i18nKeys }: CamperlabBreadcrumbsProps) {
  const breadcrumbs = useBreadcrumbI18n(i18nKeys);
  const breadcrumbsWithoutLast = breadcrumbs.map((breadcrumb, index) => {
    const last = breadcrumbs.length - 1;
    return index === last ? { ...breadcrumb, href: undefined } : breadcrumb;
  });
  return (
    <>
      <BreadcrumbsLdJson breadcrumbs={breadcrumbs} withCurrent />
      <Breadcrumbs items={breadcrumbsWithoutLast} />
    </>
  );
}
